










































































































import { Component } from 'vue-property-decorator';
import { State } from '@/vuex-decorators';
import Super from '@/Super';

@Component
export default class Header extends Super {
  @State() viewingRequestMeeting!: boolean;
  @State() viewingMedicalInformation!: boolean;
}
